import { Box, Flex, Text } from "@chakra-ui/react";

interface LegendDiscreteStepProps {
  label: string;
  color: string;
}

export function LegendDiscreteStep({ label, color }: LegendDiscreteStepProps) {
  return (
    <Flex title={label} alignItems="center" _notFirst={{ mt: 1 }}>
      <Box h={3} w={6} backgroundColor={color} borderRadius="base" />
      <Text
        fontSize={11}
        fontWeight={600}
        ml={2}
        color="brand.grey.800"
        overflow="hidden"
        whiteSpace="nowrap"
        textOverflow="ellipsis"
      >
        {label}
      </Text>
    </Flex>
  );
}
